import { chakraComponents, ControlProps, GroupBase } from 'chakra-react-select';
import { Flex } from '@chakra-ui/react';

export const Control = <Option extends {}>({
  children,
  ...props
}: ControlProps<Option, false, GroupBase<Option>>) => {
  const { customComponentsProps } = props.selectProps;
  return (
    <chakraComponents.Control {...props}>
      {customComponentsProps?.inputLeftElement && (
        <Flex paddingLeft={3} alignItems="center">
          {customComponentsProps.inputLeftElement}
        </Flex>
      )}
      {children}
    </chakraComponents.Control>
  );
};
